import "../../assets/css/community-progress.css";
import Image from "../Image/Image";
import Panel from "../Panel/PanelShimmer";
import { CommunityProgressMenu } from "./CommunityProgressMenu";

export function CommunityProgressPhaseFour(props) {
  const {loading, handleOnChange, communityPhase} = props;

  return (
    <Panel classList="community-progress__panel" shimmerProps={{height: "400px", classList: 'community-progress__panel', testId: 'community-progress'}}
    showShimmer={loading}>
        <h3 className="eta">Community Progress</h3>
        <p>Your child's community is in Phase {communityPhase}.</p>
        <CommunityProgressMenu selectedPhase={4} handleOnChange={handleOnChange}/>
        <p className="community-progress__phase-title">Phase 4: Graduate</p>
        <p>
        After years of hard work, the community becomes self-reliant and is ready to graduate. We celebrate their success and seek out the next community where God has blessings in store.
          <Image 
          src='https://wvusstatic.com/community-phases/spinning-world-phase4.gif' 
        />
        </p>
     </Panel>
    );
  }

  
export default CommunityProgressPhaseFour;